import { useEffect, useState } from "react";
import { labResultsApi, useGetLabResultsListQuery } from "../../redux/service/lab_results_service";
import { LoadingData, formattedDatePp, getFileUrl, parseResponse } from "../../utils/common_lib";
import MainPageDialog from "../../components/mainPageDialog";
import { IoMdPrint } from "react-icons/io";
import { toast } from "react-toastify";

export const LabResults = (props) => {
  const [listData, setListData] = useState([]);
  const [expandDetails, setExpandDetails] = useState({});
  const [labFileUrl, setLabFileUrl] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(false);

  const params = {
    shared_to_patient_portal: 1,
    has_result: 1,
  };
  const { data, isFetching, refetch } = useGetLabResultsListQuery(params);
  const [getPrintData] = labResultsApi.endpoints.getLabResultsPrintData.useLazyQuery();

  const cols = [
    {title: 'Date', getData: item => getFirstColData(item)},
    {title: 'Order #', key: 'order_number', colClass: 'col-md-2'},
    {title: 'Lab', key: 'lab_name', colClass: 'col-md-2'},
    {title: 'Provider', key: 'ordering_provider_name', colClass: 'col-md-3'},
    {title: 'Status', key: 'result_status', getData: item => getResultStatus(item)},
    {
      title: "Action",
      colClass: "text-center",
      getData: () => <IoMdPrint className="ml-4 text-blue-500 text-lg hover:text-blue-900" title="Print" />,
      onClick: (item) => openLabPreview(item),
    },
  ]
  const detailCols = [
    {title: 'Observations', key: 'code', colClass: 'col-md-5', addKey: 'short_desc'},
    {title: 'Result', key: 'result', colClass: 'col-md-2', addKey: 'unit'},
    {title: 'Flag', key: 'flag_text', colClass: 'col-md-3'},
    {title: 'Range', key: 'range', colClass: 'col-md-2'},
  ];

  

  const getFirstColData = item => {
    return <>
      <span className="cursor-pointer font-bold text-lg" onClick={() => toggleExpandDetails(item.id)}>
        {expandDetails[item.id] ? '-' : '+'}
      </span> 
      <span className="ml-5 inline-block">{formattedDatePp(item.order_datetime)}</span>
    </>
  }
  const getResultStatus = item => {
    let iconClass;
    if(item.reviewed==false && item.acknowledged==false){
      iconClass = 'fa fa-check cyan-color';
    }else if(item.reviewed==true){
      iconClass = 'fa fa-pencil-square-o cyan-color';
    }else if(item.acknowledged == true){
      iconClass = 'fa fa-check-circle cyan-color';
    }
    return <><span className="capitalize">{item.result_status}</span> <i className={iconClass}></i></>;
  }
  const getColData = (item, col) => {
    if(typeof col.getData == 'function'){
      return col.getData(item);
    }
    if(col.type == 'date'){
      return formattedDatePp(item[col.key], col.format || "MM/DD/YYYY hh:mm A");
    }
    if(col.type == 'amount'){
      return `$${item[col.key] || '0'}`;
    }
    return item[col.key] || '';
  }
  const toggleExpandDetails = id => {
    let expands = {...expandDetails};
    if(expands[id]){
      expands[id] = false;
    }else{
      expands[id] = true;
    }
    setExpandDetails(expands);
  }

  const openLabPreview = async(item) => {
    setLoadingPdf(true);
    setLabFileUrl('startLoading');
    const res = await getPrintData({lab_order_id: item.id});
    const {data, code} = parseResponse(res);
    if(data?.file_uuid){
      const docUrl = getFileUrl(data.file_uuid);
      setLabFileUrl(docUrl);
    }else{
      toast.error('Print data not found.');
      setLabFileUrl(null);
    }
  }

  useEffect(() => {
    if (data?.data) {
      setListData(data?.data || []);
    }
  }, [data]);

  const printResult = () => {
    window.open(labFileUrl + "#toolbar=0&navpanes=0&scrollbar=0", '_blank');
    setLabFileUrl(null);
  }

    return (
        <>
            <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
                <div className="">
                    <h3 className="text-base font-semibold leading-6 text-gray-900">Lab Results</h3>
                </div>
                <div className=" flex-shrink-0">
                    <button
                        type="button"
                        onClick={refetch}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                        Reload
                    </button>
                </div>
            </div>
            <div className="flex-auto bg-white justify-start p-3 text-start">
              <div className="flow-root">
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-4 lg:-mx-6">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-4 lg:px-6">
                    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                          <thead className="bg-gray-50">
                            <tr className="font-bold">
                              {cols.map((col, colIndex) => {
                                return (
                                  <>
                                    <th key={`col_title_${colIndex}`} scope="col" className="py-3.5 px-3 text-left text-sm font-bold text-slate-500">
                                      {col.title}
                                    </th>
                                  </>
                                )
                              })}
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 bg-white">      
                            {isFetching ? <tr><td colSpan={cols.length}><LoadingData /></td></tr> : ''}
                            {!isFetching && !listData?.length ? 
                            <tr><td colSpan={cols.length} className="p-2 text-center">
                              No results found.
                            </td></tr> : ''}
                            <>
                              {listData?.map((item, itemIndex) => { 
                                return (
                                  <>
                                    <tr>
                                      {cols.map((col, colIndex) => 
                                      <td className="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900 ">
                                        <span
                                          title={col.el_title || col.title}
                                          onClick={() => {
                                            if (
                                              typeof col.onClick === "function"
                                            ) {
                                              col.onClick(item, col);
                                            }
                                          }}
                                          class={`${
                                            col.onClick
                                              ? "cursor-pointer text-primary"
                                              : ""
                                          } 
                                          ${col?.colClass && col?.colClass}`}
                                        >
                                          {getColData(item, col)}
                                        </span>
                                      </td>)}
                                    </tr>
                                    {expandDetails[item.id] ? 
                                        <tr>
                                          <td colSpan={cols.length}>
                                            <div className="p-2">
                                              <table className="w-full bg-gray-100 p-2">
                                                <tbody>
                                                  {item.LabTests?.map((testItem, testIndex) => {
                                                    return (
                                                      <>
                                                        <tr className="font-bold">
                                                          <td colSpan={detailCols.length} className="whitespace-nowrap py-4 px-3 font-medium text-[#4e9beb]">
                                                            {testItem.code ? <span className="mr-2">{testItem.code}</span> : ''}
                                                            {testItem.short_desc ? <span className="mr-2"> - {testItem.short_desc}</span> : ''}
                                                            {item.has_result && testItem.result_datetime && testItem.result_datetime !='' ? 
                                                            <span>
                                                              Result Date: {formattedDatePp(testItem.result_datetime, 'MM/DD/YYYY HH:mm A')}
                                                            </span> : ''}
                                                          </td>
                                                        </tr>
                                                        <tr className="font-bold border-b border-slate-300">{detailCols.map((dCol, dColIndex) => <td className="whitespace-nowrap py-4 px-3 text-sm font-bold">{dCol.title}</td>)}</tr>
                                                        {testItem.TestResults?.map((resItem, resIndex) => {
                                                          return <tr>
                                                            {detailCols.map((dCol, dColIndex) => {
                                                              return <td className="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900">{resItem[dCol.key]} {dCol.addKey && resItem[dCol.addKey] ? resItem[dCol.addKey] : ''}</td>
                                                            })}
                                                          </tr>
                                                        })}
                                                      </>
                                                    )
                                                  })}
                                                </tbody>
                                              </table>
                                            </div>
                                          </td>
                                        </tr> : ''
                                      }
                                  </>
                                )
                              })}
                            </>        
                          </tbody>
                        </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* dialogs */}
            {labFileUrl && <MainPageDialog
              title="Preview"
              modalSize="lg"
              footerList={[
                {type: 'close', title: 'Close', action: () => {setLabFileUrl(null)}},
                {type: 'save', title: 'Print', action: printResult}
              ]}
              onCancelHandler={() => setLabFileUrl(null)}
            >
              <>
                {loadingPdf && <LoadingData msg="Loading print data..." />}
                <embed src={labFileUrl} onLoad={() => {setLoadingPdf(false)}} className="pdfviewer-scroller" width="100%" height="100%" type="application/pdf"></embed>
              </>
            </MainPageDialog>}
        </>
    )
}
